const getValueWhenDirty = <T>(
  payload: T | Partial<T>,
  key: keyof T,
  dirtyFieldIndicator: unknown,
  dirtyValues: Record<Partial<keyof T> | string, unknown>,
  payloadValue: unknown,
) => {
  if (
    typeof dirtyFieldIndicator === 'boolean' &&
    dirtyFieldIndicator === true
  ) {
    // We take the value directly from the payload.
    if (Object.hasOwn(payload as object, key)) {
      dirtyValues[key] = payloadValue;
    }
  } else if (
    // If dirtyFieldIndicator is an object, it means there are nested dirty fields.
    typeof dirtyFieldIndicator === 'object' &&
    dirtyFieldIndicator !== null
  ) {
    // Recursively call the function for nested objects.
    if (
      Object.hasOwn(payload as object, key) &&
      typeof payloadValue === 'object' &&
      payloadValue !== null
    ) {
      const nestedDirtyValues = getFormDirtyValues(
        payloadValue as Partial<T>,
        dirtyFieldIndicator as Record<Partial<keyof T>, unknown>,
      );
      if (Object.keys(nestedDirtyValues).length > 0) {
        dirtyValues[key] = nestedDirtyValues;
      }
    }
  }
};

// The purpose of this is only get what was changed from the default values only
export const getFormDirtyValues = <T>(
  payload: T | Partial<T>,
  dirtyFields: Record<Partial<keyof T>, unknown>,
) => {
  const dirtyValues: Record<Partial<keyof T> | string, unknown> = {} as Record<
    Partial<keyof T> | string,
    unknown
  >;

  for (const key in dirtyFields) {
    if (Object.hasOwn(dirtyFields, key)) {
      // dirtyFields[key] can be a nested object or a boolean, if it is boolean, it means the field was updated
      const dirtyFieldIndicator = dirtyFields[key];
      const payloadValue = payload[key];

      // If dirtyFieldIndicator is true, it means this field was updated.
      getValueWhenDirty(
        payload,
        key,
        dirtyFieldIndicator,
        dirtyValues,
        payloadValue,
      );
    }
  }
  return dirtyValues;
};
